(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-video-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class CustomVideoHeroSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.timer = null;
      this.endHandler = null;
      this.isTransitioning = false;
      this.isVisible = false;
    }

    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (this.slides.length === 0) return;

      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.prevBtn = this.querySelector('[data-prev]');
      this.nextBtn = this.querySelector('[data-next]');

      this.autoplay = this.dataset.autoplay === 'true';
      this.loop = this.dataset.loop === 'true';
      this.duration = (parseInt(this.dataset.duration, 10) || 6) * 1000;
      this.advanceMode = this.dataset.advanceMode || 'video_end';

      this.bindEvents();
      this.setupVisibilityObserver();
      this.prepareAllVideos();
      this.activateSlide(0, false);
    }

    disconnectedCallback() {
      this.clearTimer();
      this.removeEndHandler();
      if (this.observer) this.observer.disconnect();
      if (this._visHandler) document.removeEventListener('visibilitychange', this._visHandler);
    }

    bindEvents() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.goPrev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.goNext());

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const i = parseInt(dot.dataset.dotIndex, 10);
          this.goTo(i);
        });
      });

      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.goPrev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.goNext(); }
      });

      let touchStartX = 0;
      let touchStartY = 0;
      let touchActive = false;

      this.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        touchActive = true;
      }, { passive: true });

      this.addEventListener('touchend', (e) => {
        if (!touchActive) return;
        touchActive = false;
        const dx = e.changedTouches[0].screenX - touchStartX;
        const dy = e.changedTouches[0].screenY - touchStartY;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) {
          dx < 0 ? this.goNext() : this.goPrev();
        }
      }, { passive: true });

      const isFinePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (isFinePointer) {
        this.addEventListener('mouseenter', () => this.pauseAdvance());
        this.addEventListener('mouseleave', () => this.resumeAdvance());
      }

      this._visHandler = () => {
        if (document.hidden) {
          this.pauseAllVideos();
          this.pauseAdvance();
        } else if (this.isVisible) {
          this.playCurrentVideo();
          this.resumeAdvance();
        }
      };
      document.addEventListener('visibilitychange', this._visHandler);
    }

    setupVisibilityObserver() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            this.isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
            if (this.isVisible) {
              this.playCurrentVideo();
              this.resumeAdvance();
            } else {
              this.pauseAllVideos();
              this.pauseAdvance();
            }
          });
        },
        { threshold: [0, 0.25, 0.5] }
      );
      this.observer.observe(this);
    }

    prepareAllVideos() {
      this.querySelectorAll('[data-slide-video]').forEach((video) => {
        const onReady = () => { video.classList.add('is-ready'); };
        if (video.readyState >= 2) {
          onReady();
        } else {
          video.addEventListener('loadeddata', onReady, { once: true });
          video.addEventListener('canplay', onReady, { once: true });
        }
      });
    }

    getActiveVideo(slideIndex) {
      const slide = this.slides[slideIndex];
      if (!slide) return null;
      const isMobile = window.matchMedia('(max-width: 749px)').matches;
      const selector = isMobile ? '[data-slide-video-mobile]' : '[data-slide-video-desktop]';
      return slide.querySelector(selector) || slide.querySelector('[data-slide-video]');
    }

    activateSlide(index, animate = true) {
      if (animate && this.isTransitioning) return;
      if (animate && index === this.currentIndex) return;

      const prevIndex = this.currentIndex;
      this.isTransitioning = true;
      this.removeEndHandler();
      this.clearTimer();

      this.slides.forEach((slide, i) => {
        const isActive = i === index;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        const btn = slide.querySelector('[data-slide-button]');
        if (btn) btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      this.dots.forEach((dot, i) => {
        const isActive = i === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      if (prevIndex !== index) {
        const prevVideo = this.getActiveVideo(prevIndex);
        if (prevVideo) {
          try {
            prevVideo.pause();
            prevVideo.currentTime = 0;
          } catch (_) {}
        }
      }

      this.currentIndex = index;

      const activeVideo = this.getActiveVideo(index);
      if (activeVideo && activeVideo.preload === 'metadata') {
        activeVideo.preload = 'auto';
      }

      if (this.isVisible || !animate) {
        this.playCurrentVideo();
      }

      window.setTimeout(() => {
        this.isTransitioning = false;
      }, 600);

      this.resumeAdvance();
    }

    playCurrentVideo() {
      const video = this.getActiveVideo(this.currentIndex);
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    }

    pauseAllVideos() {
      this.querySelectorAll('[data-slide-video]').forEach((v) => {
        try { v.pause(); } catch (_) {}
      });
    }

    resumeAdvance() {
      this.clearTimer();
      this.removeEndHandler();
      if (!this.autoplay || this.slides.length <= 1) return;
      if (!this.isVisible) return;

      const video = this.getActiveVideo(this.currentIndex);

      if (this.advanceMode === 'video_end' && video) {
        const handler = () => {
          if (!video.duration || isNaN(video.duration)) return;
          if (video.currentTime >= video.duration - 0.15) {
            video.removeEventListener('timeupdate', handler);
            this.endHandler = null;
            this.goNext();
          }
        };
        video.addEventListener('timeupdate', handler);
        this.endHandler = { video, handler };
      } else {
        this.timer = window.setTimeout(() => this.goNext(), this.duration);
      }
    }

    pauseAdvance() {
      this.clearTimer();
      this.removeEndHandler();
    }

    clearTimer() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    }

    removeEndHandler() {
      if (this.endHandler) {
        try {
          this.endHandler.video.removeEventListener('timeupdate', this.endHandler.handler);
        } catch (_) {}
        this.endHandler = null;
      }
    }

    goNext() {
      let next = this.currentIndex + 1;
      if (next >= this.slides.length) {
        if (!this.loop) return;
        next = 0;
      }
      this.activateSlide(next);
    }

    goPrev() {
      let prev = this.currentIndex - 1;
      if (prev < 0) {
        if (!this.loop) return;
        prev = this.slides.length - 1;
      }
      this.activateSlide(prev);
    }

    goTo(index) {
      if (index < 0 || index >= this.slides.length) return;
      this.activateSlide(index);
    }
  }

  if (!customElements.get('custom-video-hero-slider')) {
    customElements.define('custom-video-hero-slider', CustomVideoHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
